export default {
    name: 'summary-report',
    displayName: '专利活力报告',
    tabIndex: 999, // 确保在菜单中靠后显示
    exclusiveRoutePath: '/summary-report',
    fullView: true,
    getComponent: () => import('./SummaryReport.vue'),
}; 